import React, { useState } from "react";
import MenuIcon from "@mui/icons-material/Menu";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";

const Navbar = () => {
    const [menuOpen, setMenuOpen] = useState(false);

    return (
        <nav style={{
            backgroundColor: "#365f91",
            color: "white",
            padding: "10px 20px",
            fontSize: "1.2rem",
            fontWeight: "bold",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "wrap",
            boxShadow: "0 2px 4px rgba(0,0,0,0.2)"
        }}>
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                <MenuIcon
                    onClick={() => setMenuOpen(!menuOpen)}
                    style={{ cursor: "pointer" }}
                    fontSize="large"
                />
                <LocalShippingIcon fontSize="large" />
                <span style={{ fontSize: "1.1rem" }}>RX Route Planner</span>
            </div>

            <div style={{
                display: menuOpen ? "block" : "none",
                width: "100%",
                marginTop: "10px",
                fontSize: "0.95rem",
                fontWeight: "normal"
            }}>
                <div style={{ borderTop: "1px solid rgba(255,255,255,0.2)", paddingTop: "10px" }}>
                    Powered by rxsoft.pl – Sebastian & Cezary
                </div>
            </div>

            <div className="desktop-only" style={{
                display: "none",
                fontSize: "0.95rem",
                fontWeight: "normal"
            }}>
                Powered by rxsoft.pl – Sebastian & Cezary
            </div>

            <style>{`
                @media (min-width: 640px) {
                    .desktop-only {
                        display: block !important;
                    }
                    nav > div:nth-child(3) {
                        display: none !important;
                    }
                }
            `}</style>
        </nav>
    );
};

export default Navbar;